import { useSelector } from 'react-redux';
import Account from 'modules/Account';
import { SELECTABLE_GLUCOSE_UNIT_TYPE_COUNTRY_CODES } from '../../../../constants';
export const useIsGlucoseLevelUnitTypesRequired = ()=>{
    const account = useSelector(Account.selectors.account);
    return SELECTABLE_GLUCOSE_UNIT_TYPE_COUNTRY_CODES.includes(account.countryCode);
};
